import styled from '@emotion/styled';

import { spacing, borderRadius, transitions } from '../tokens';

const DIVIDER = '#D9D9D9';
const ICON = '#3D3D3D';
const FOCUS = '#000FFF';

/**
 * Container do SearchBar: input (flex) + divisória tracejada + ação.
 */
export const SearchBarRoot = styled('div')`
  display: flex;
  align-items: center;
  gap: ${spacing.lg};
  width: 100%;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

/**
 * Área do input — ocupa o espaço disponível.
 */
export const InputArea = styled('div')`
  flex: 1;
  min-width: 0;
`;

/**
 * Divisória vertical tracejada entre o input e a ação (igual ao Figma).
 */
export const SearchBarDivider = styled('span')`
  width: 0;
  align-self: stretch;
  min-height: 32px;
  border-left: 1px dashed ${DIVIDER};
  flex-shrink: 0;

  @media (max-width: 640px) {
    display: none;
  }
`;

/**
 * Área da ação (slot — ex.: botão "Selecionar todos").
 */
export const ActionArea = styled('div')`
  flex-shrink: 0;
`;

/**
 * Lupa clicável (quando `onSearch` é fornecido).
 */
export const SearchIconButton = styled('button')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  color: ${ICON};
  cursor: pointer;
  line-height: 0;
  transition: opacity ${transitions.fast};

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus-visible {
    outline: 2px solid ${FOCUS};
    outline-offset: 2px;
    border-radius: ${borderRadius.md};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;
